import React from "react";
import { Icon } from "@shared/components/Icon";

import "./index.scss";

interface FileZoneUploadedFileInfoProps {
  file: File;
  onDeleteFile: () => void;
}

const FileZoneUploadedFileInfo = ({ file, onDeleteFile }: FileZoneUploadedFileInfoProps) => {
  return (
    <div className="file-zone-uploaded-file-info">
      <div className="file-name">{file.name}</div>
      <div className="file-delete">
        <Icon type="delete-red" onClick={onDeleteFile} />
      </div>
    </div>
  );
};

export default FileZoneUploadedFileInfo;
